import {AuthGuard} from '../../shared/guards/AuthGuard';
import {PermissionsDetailsPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const PermissionsDetailsPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <PermissionsDetailsPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};